import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaTipoJanela from './Components/TabelaTipoJanela'




function TipoJanela() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const headers = [
      { label: 'Selecionar', key: 'checkbox', isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Tipo de Janela', key: 'tipojanela', isVisible: true },
      { label: 'Descrição', key: 'descricao', isVisible: true },
      { label: 'Observação', key: 'observacao', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];
    
    const mockPermissions = [
      {
        id: 1,
        tipojanela: 'Carregamento',
        descricao: 'Resfriados',
        observacao: 'Resfriados',
        ativo: true,
      },
      {
        id: 2,
        tipojanela: 'Recebimento',
        descricao: 'Secos',
        observacao: 'Secos',
        ativo: false,
      },
      {
        id: 3,
        tipojanela: 'Expedição',
        descricao: 'Congelados',
        observacao: 'Congelados',
        ativo: true,
      },
    ];
    

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Tipo de Janela'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaTipoJanela headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default TipoJanela